import { IMenuItem } from './types';
import { MenuSidebarItem } from './MenuSidebarItem';

export const MenuSidebarList = ({ menu }: { menu: IMenuItem[] }) => {
  return (<ul className='menu-sidebar-list'>
    {menu.filter((el) => !el.disabled).map((el, i) =>
      <MenuSidebarItem key={i} menuItem={el} />)}
  </ul>);
};
